import React from "react";

export default function DealerConfirmationPopUp(props) {
    return (
        <>
            <div className="container my-5 mx-auto px-2 md:px-5">
                <div className="w-full mt-8 mx-auto">
                    <p className="openSans-Light text-black mt-3 mb-3 text-base md:text-lg">
                        Please ensure that the Dealer selected by you is correct
                        since the disbursement would be credited to the said
                        dealer only . You can validate the Dealer correctness by
                        checking the Dealer 's address displayed in the screen
                        as there can be different Dealer with the same name.
                    </p>
                </div>
                <div className="w-full flex flex-wrap my-8">
                    <button
                        className="button-blue-bg text-white py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue  mb-2 mr-0 sm:mr-2 md:mr-2 lg:mr-3 xl:mr-4"
                        title="Confirm"
                        onClick={() => props.onclickhandler()}
                    >
                        Confirm
                    </button>
                    <button
                        className="bg-transparent border-2 button-blue-border blue-link-color hover:text-white py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue button-white-blue mb-2 transition-all text-center"
                        title="Cancel"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </>
    );
}
